// Phone number formatter - formats to (XXX) XXX-XXXX
export const formatPhoneNumber = (value) => {
  if (!value) return '';
  
  // Remove all non-digits
  const phoneNumber = value.replace(/\D/g, '');
  
  // Format based on length
  if (phoneNumber.length < 4) {
    return phoneNumber;
  } else if (phoneNumber.length < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  } else {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  }
};

// Handle phone input change - allows typing and formats on blur
export const handlePhoneChange = (value, setter, field = 'phone') => {
  // Allow typing with partial formatting
  const digits = value.replace(/\D/g, '').slice(0, 10);
  setter(prev => ({ ...prev, [field]: digits }));
};

export const handlePhoneBlur = (value, setter, field = 'phone') => {
  // Format on blur
  const formatted = formatPhoneNumber(value);
  setter(prev => ({ ...prev, [field]: formatted }));
};

// Role labels for display
export const roleLabels = {
  admin: "Admin",
  dispatch: "Dispatch",
  data_entry: "Data Entry",
  technician: "Technician",
  yard_goat_operator: "Yard-goat Operator",
  office_clerk: "Office Clerk",
  driver: "Driver",
  director: "Director",
  yard_checker: "Yard Checker",
  master_admin: "Master Admin",
  supervisor: "Supervisor"
};

// Role badge colors
export const roleBadgeColors = {
  admin: "bg-purple-100 text-purple-700",
  dispatch: "bg-blue-100 text-blue-700",
  data_entry: "bg-slate-100 text-slate-700",
  technician: "bg-green-100 text-green-700",
  yard_goat_operator: "bg-yellow-100 text-yellow-700",
  office_clerk: "bg-pink-100 text-pink-700",
  driver: "bg-cyan-100 text-cyan-700",
  director: "bg-indigo-100 text-indigo-700",
  yard_checker: "bg-orange-100 text-orange-700",
  master_admin: "bg-red-100 text-red-700",
  supervisor: "bg-teal-100 text-teal-700"
};

// Available positions
export const positions = [
  { value: "admin", label: "Admin" },
  { value: "dispatch", label: "Dispatch" },
  { value: "data_entry", label: "Data Entry" },
  { value: "technician", label: "Technician" },
  { value: "yard_goat_operator", label: "Yard-goat Operator" },
  { value: "office_clerk", label: "Office Clerk" },
  { value: "driver", label: "Driver" },
  { value: "supervisor", label: "Supervisor" },
  { value: "director", label: "Director" },
  { value: "yard_checker", label: "Yard Checker" }
];
